<template>
  <div class="main-footer__currency-select">
    <div class="main-footer__currency-select-title">
      {{ $tFooter('Currency') }}
    </div>
    <div class="select-dropdown">
      <button type="button"
              class="select-dropdown__trigger"
              @click.prevent.stop="onOpen">
        <span v-if="currentCurrency.currency === 'ALL'"
              class="select-dropdown__trigger-current">
          {{ $tGlobal('currency_all') }}
        </span>
        <span v-else
              class="select-dropdown__trigger-current">
          {{ currentCurrency.currency }} / {{ currentCurrency.symbol }}
        </span>
        <BaseSvg name="ico-arrow"
                 class="select-dropdown__trigger-arrow"/>
      </button>
      <transition name="dropdown">
        <div v-if="isOpen"
             v-click-out="onClose"
             class="select-dropdown__dropdown">
          <button type="button"
                  class="select-dropdown__close"
                  @click.prevent="onClose"
          >
            <BaseSvg name="ico-close"
                     width=".8rem"
                     height=".8rem"/>
          </button>
          <div class="select-dropdown__options">
            <a v-for="item in currencies"
               :key="item.id"
               :href="`#${item.currency}`"
               @click.prevent="onInput(item)"
               class="select-dropdown__option"
               :class="{'_active': currentCurrency === item}"
            >
              <span v-if="item.currency === 'ALL'">{{ $tGlobal('currency_all') }}</span>
              <span v-else>{{ item.currency }} / {{ item.symbol }}</span>
            </a>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FooterCurrencySelect',
    data() {
      return {
        isOpen: false
      }
    },
    computed: {
      currencies() {
        return this.$store.state.currencies
      },
      currentCurrency() {
        return this.$store.state.currentCurrency
      }
    },
    methods: {
      onInput(event) {
        const currentCurrency = this.currencies.find(currency => currency.id === +event.id)
        if (currentCurrency) {
          this.$store.dispatch('changeCurrentCurrency', currentCurrency)
        }
      },
      getOptionText(option) {
        return option.currency === 'ALL'
          ? this.$tGlobal('currency_all')
          : `${option.currency} / ${option.symbol}`
      },
      onOpen() {
        this.isOpen = true
      },
      onClose() {
        this.isOpen = false
      }
    }
  }
</script>

<style lang="less">

</style>
